import useSWR from 'swr';
import { Table, Spin, Button, Flex, Input, Popconfirm } from 'antd';
import { useState } from 'react';
import { handleCreateProject, handleDeleteProject } from '../api/projects.api';
import { DeleteOutlined } from '@ant-design/icons';
import { Project } from '../constants';

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: '30%',
  },
  {
    title: 'Titre',
    dataIndex: 'title',
    key: 'title',
    width: '65%',
  },
  {
    title: 'Action',
    key: 'action',
    width: '5%',
    render: (_: void, record: Project) => (
      <Popconfirm
        title="Êtes-vous sûr?"
        onConfirm={(e) => {
          e?.stopPropagation();
          handleDeleteProject(record.id);
        }}
        onCancel={(e) => e?.stopPropagation()}
        okText="Yes"
        cancelText="No"
      >
        <Button danger onClick={(e) => e.stopPropagation()}>
          <DeleteOutlined />
        </Button>
      </Popconfirm>
    ),
  },
];

const ProjectList = () => {
  const { data, error, isLoading } = useSWR<any[]>('/projects');
  const [isAdding, setIsAdding] = useState<boolean>(false);
  const [value, setValue] = useState<string>('');

  if (isLoading) {
    return <Spin />;
  }

  if (error) {
    return <div>Une erreur est survenue</div>;
  }

  const handleAdd = async () => {
    setIsAdding(true);
    await handleCreateProject({
      title: value,
    });
    setIsAdding(false);
    setValue('');
  };

  const isDisabled = isAdding || isLoading || !value;

  return (
    <div>
      <h1 style={{ marginRight: '24px' }}>{`Projets (${data?.length})`}</h1>

      <Flex style={{ width: '300px', marginBottom: '24px' }}>
        <Input
          disabled={isAdding || isLoading}
          placeholder="Ajouter un nouveau projet"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <Button
          disabled={isDisabled}
          loading={isAdding}
          style={{
            marginLeft: '12px',
            lineHeight: '21px',
          }}
          type="primary"
          onClick={handleAdd}
        >
          Ajouter
        </Button>
      </Flex>

      <Table
        style={{ overflow: 'auto', height: '800px' }}
        dataSource={data}
        columns={columns}
        pagination={false}
        rowKey={(row: any) => row.id}
      />
    </div>
  );
};

export default ProjectList;
